import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft } from "lucide-react";
import { I18nProvider, useT } from "@/i18n/I18nProvider";
import Logo from "@/components/Logo";

// The thank_you page is Spanish only per requirements.
function ThankYouInner() {
  const t = useT();
  useEffect(() => {
    document.title = `${t("thanks.title")}`;
    document.documentElement.setAttribute("lang", "es-AR");
  }, [t]);
  return (
    <main className="dma-thanks">
      <div className="dma-thanks__inner">
        <Link to="/" className="dma-thanks__brand" aria-label="Dataminerarg">
          <Logo />
        </Link>
        <div className="dma-thanks__card">
          <span className="dma-thanks__icon" aria-hidden="true">
            <CheckCircle2 size={36} />
          </span>
          <span className="dma-eyebrow">{t("thanks.eyebrow")}</span>
          <h1>{t("thanks.title")}</h1>
          <p>{t("thanks.text")}</p>
          <Link to="/" className="dma-btn dma-btn--primary">
            <ArrowLeft size={16} />
            {t("thanks.back")}
          </Link>
        </div>
      </div>
    </main>
  );
}

export default function ThankYou() {
  return (
    <I18nProvider lang="ar">
      <ThankYouInner />
    </I18nProvider>
  );
}
